import React, { useState, useEffect } from 'react';
import './resetpass.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const ResetPass = () => {
  const [email, setEmail] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);

  // Verifica se existe token na URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenUrl = params.get('token');
    if (tokenUrl) {
      setToken(tokenUrl);
    }
  }, []);

  /* ===============================
     ETAPA 1 — SOLICITAR RESET
  ================================ */
  const handleRequestReset = async (e) => {
    e.preventDefault();
    setErro('');
    setMensagem('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/resetpass.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      setMensagem(data.mensagem || 'Se o e-mail existir, você receberá instruções.');

    } catch (error) {
      setErro('Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     ETAPA 2 — CONFIRMAR RESET
  ================================ */
  const handleConfirmReset = async (e) => {
    e.preventDefault();
    setErro('');
    setMensagem('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/resetpass-confirm.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          token,
          nova_senha: novaSenha
        })
      });

      const data = await response.json();

      if (data.status === 'sucesso') {
        setMensagem(data.mensagem);
      } else {
        setErro(data.mensagem || 'Erro ao redefinir senha.');
      }

    } catch (error) {
      setErro('Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="login-background"
        style={{
          backgroundImage: "url('/assets/loginimage.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          position: 'relative'
        }}
      >
        <div className="login-overlay"></div>

        <div className="login-container">
          <div className="login-form">
            <img
              src="/assets/logo1.png"
              alt="Logo NutriFácil"
              className="login-logo"
            />

            {/* ===============================
                ETAPA 1 — E-MAIL
            ================================ */}
            {!token && (
              <>
                <h2 className="login-title">Recuperar acesso</h2>

                <form onSubmit={handleRequestReset}>
                  <input
                    type="email"
                    placeholder="Seu e-mail cadastrado"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />

                  <button type="submit" disabled={loading}>
                    {loading ? 'Enviando...' : 'Enviar instruções'}
                  </button>

                  {mensagem && <p style={{ color: '#333' }}>{mensagem}</p>}
                  {erro && <p className="login-error">{erro}</p>}
                </form>
              </>
            )}

            {/* ===============================
                ETAPA 2 — NOVA SENHA
            ================================ */}
            {token && (
              <>
                <h2 className="login-title">Nova senha</h2>

                <form onSubmit={handleConfirmReset}>
                  <input
                    type="password"
                    placeholder="Digite sua nova senha"
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    required
                  />

                  <button type="submit" disabled={loading}>
                    {loading ? 'Salvando...' : 'Redefinir senha'}
                  </button>

                  {mensagem && (
                    <>
                      <p style={{ color: '#28a745' }}>{mensagem}</p>
                      <a href="/login" style={{ marginTop: 10, display: 'block' }}>
                        Ir para o login
                      </a>
                    </>
                  )}

                  {erro && <p className="login-error">{erro}</p>}
                </form>
              </>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ResetPass;
